import getImage from './GetImage';
import pdfMake from 'pdfmake/build/pdfmake.js';
import moment from 'moment';
import { calculateAgeParse } from '../../../../Utils/Patient';
import ReportsAPI from './../../../../Reports/api/reports_api';

const PdfProceduresFormat = async (data) => {

    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        }
    };

    const { nombres, apellido1, apellido2, reg_medico, especialidad } = data.professional;
    let esp = especialidad !== undefined ? especialidad : '';
    let docContent = [];

    let body = [];

    const city = data.profile.direccion.id_ciudad;
    const dept = data.profile.direccion.id_dpto;
    const getCity = await ReportsAPI.loadCity(city);
    const getDepts = await ReportsAPI.loadDepartment();
    const deptoProfile = getDepts.find((depto) => depto.id === dept)
    console.log("location", getCity, deptoProfile)

    const format_today = moment(data.infoAdmission?.admision?.fecha).format('DD [de] MMMM [de] YYYY');

    const fecha = moment(data.today).format('DD-MM-YYYY');
    const name = data.typeOfDocument + '-' + data.documentNumber + ' ' + data.names;

    let urlServe = process.env.REACT_APP_PUBLIC_URL + 'profesional/ver-firma/' + data.id_profesional + '/' + sessionStorage.getItem('token');
    let urlFirma = '';
    //let urlServe = process.env.REACT_APP_PUBLIC_URL+  'profesional/ver-firma/11/' +   sessionStorage.getItem('token');
    //console.log(urlFirma);
    let test = fetch(urlServe)
        .then(response => {
            if (response.status === 500) {
                return false;
            } else {
                return true;
            }
        });

    let isImg = await test;

    if (isImg) {
        urlFirma = urlServe;
    } else {
        urlFirma = 'https://i.postimg.cc/0jznYVsr/prueba.png';
    }

  const supportDoc = data.medicoApoyo;

  let tableBodySignatures1 = [
    {
        unbreakable: true,
        layout: 'headerLineOnly',
        border: [false, false, false, false],
        table: {
            widths: [125],
            headerRows: 1,
            alignment: 'center',
            body: [
                [{
                    image: await getImage(data.firmDoctor),
                    fit: [100, 25],
                    alignment: 'center'
                }],
                [{ text: 'Dr. ' + data.professional.nombres + ' ' + data.professional.apellido1 + ' ' + data.professional.apellido2 + '\n'
                    + data.professional.especialidad + '\n REG-' + data.professional.reg_medico, style: 'medicStyle'}]
            ]
        },
    },
  ];


  for(let j = 0; j<supportDoc.length; j++){
    let supportDocInfo = supportDoc[j];
    let firmUrl = data.firmDoctorSupport[j];

    if(data.suportDoc !== null){
        tableBodySignatures1.push({
            unbreakable: true,
            layout: 'headerLineOnly',
            border: [false, false, false, false],
            table: {
                widths: [125],
                headerRows: 1,
                alignment: 'center',
                body: [
                    [{
                        image: await getImage(firmUrl),
                        fit: [100, 25],
                        alignment: 'center'
                    }],
                    [{  text: supportDocInfo.titulo + " " + supportDocInfo.nombres + " " + supportDocInfo.apellido1 + '\n' + supportDocInfo.especialidad + '\nREG-' + supportDocInfo.reg_medico, 
                    style: 'medicStyle'}]
                ]
            },
        })
    }
  }

  let signatures1 = [
    {
        unbreakable: true,
        pageBreak: 'after',
        margin: [10, 20, 50, 0],
        layout: {
            paddingTop: function (index, node) {
                applyVerticalAlignment(node, index, 'bottom');
                return 0;
            },
            defaultBorder: false,
        },
        table: {
            widths: ['*', '*', '*'],
            headerRows: 1,
            body: [
                    tableBodySignatures1
            ]
        },
    }
  ];

  async function generateSignature(breakPage){
    let tableBodySignatures = [
        {
            unbreakable: true,
            layout: 'headerLineOnly',
            border: [false, false, false, false],
            table: {
                widths: [125],
                headerRows: 1,
                alignment: 'center',
                body: [
                    [{
                        image: await getImage(data.firmDoctor),
                        fit: [100, 25],
                        alignment: 'center'
                    }],
                    [{ text: 'Dr. ' + data.professional.nombres + ' ' + data.professional.apellido1 + ' ' + data.professional.apellido2 + '\n'
                        + data.professional.especialidad + '\n REG-' + data.professional.reg_medico, style: 'medicStyle'}]
                ]
            },
        },
    ];

    for(let j = 0; j<supportDoc.length; j++){
        let supportDocInfo = supportDoc[j];
        let firmUrl = data.firmDoctorSupport[j];
    
        if(data.suportDoc !== null){
            tableBodySignatures.push({
                unbreakable: true,
                layout: 'headerLineOnly',
                border: [false, false, false, false],
                table: {
                    widths: [125],
                    headerRows: 1,
                    alignment: 'center',
                    body: [
                        [{
                            image: await getImage(firmUrl),
                            fit: [100, 25],
                            alignment: 'center'
                        }],
                        [{  text: supportDocInfo.titulo + " " + supportDocInfo.nombres + " " + supportDocInfo.apellido1 + '\n' + supportDocInfo.especialidad + '\nREG-' + supportDocInfo.reg_medico, 
                        style: 'medicStyle'}]
                    ]
                },
            })
        }
    }
    let signatures = [
        {
            unbreakable: true,
            pageBreak: breakPage,
            margin: [10, 20, 50, 0],
            layout: {
                paddingTop: function (index, node) {
                    applyVerticalAlignment(node, index, 'bottom');
                    return 0;
                },
                defaultBorder: false,
            },
            table: {
                widths: ['*', '*', '*'],
                headerRows: 1,
                body: [
                        tableBodySignatures
                ]
            },
        }
    ];
    return signatures;
  }

  const signatures3 = await generateSignature();
  const signatures4 = await generateSignature();
  const signatures5 = await generateSignature();


    const header = {
        margin: [40, 10, 0, 0],
        layout: 'noBorders',
        table: {
            widths: ['*', '*'],
            body: [
                [{
                    image: await getImage(data.urlLogo),
                    fit: [100, 40],
                },
                { text: data.profile.nombre + '\n Nit: ' + data.profile.nit + '\n' + data.profile.direccion.direccion + ' \n Teléfonos: ' + data.profile.telefono1 + '-' + data.profile.telefono2 + ' \n Fecha de Atención: ' + data.day, style: 'head' }],

            ]
        },
    };

    const basicPatientInfo = () => {
        return {
            // auto-sized columns have their widths based on their content     
            unbreakable: true,
            margin: [0, 5, 0, 10],
            layout: {
                defaultBorder: false,
            },
            table: {
                headerRows: 1,
                widths: ['auto', '*', 'auto', '*'],
                body: [
                    [{ text: 'Datos del Paciente ', style: 'tableheader', colSpan: 4,  border: [false, false, false, true] }, '', '', ''],
                    [{ text: 'Nombre ', bold: true, style: 'textStyle' }, { text: data.names, style: 'textStyle' },
                    { text: 'Documento de Identificación: ', bold: true, style: 'textStyle' }, { text: data.typeOfDocument + ' ' + data.documentNumber, style: 'textStyle' }],
                    [{ text: 'Edad ', bold: true, style: 'textStyle' }, { text: calculateAgeParse(data.birthday), style: 'textStyle' },
                    { text: 'Genero ', bold: true, style: 'textStyle' }, { text: data.gender, style: 'textStyle' }],
                    [{ text: 'Historia Clínica ', bold: true, style: 'textStyle',  border: [false, false, false, true] }, { text: data.id_historia !== undefined && data.id_historia !== null ? data.id_historia : '', style: 'textStyle',  border: [false, false, false, true] },
                    { text: 'Regimen ', bold: true, style: 'textStyle',  border: [false, false, false, true] }, { text: data.regime !== undefined && data.regime !== null ? data.regime : '', style: 'textStyle',  border: [false, false, false, true] }],
                ]
            },
        }
    }


    const diagnosticsCie10 = () => {
        let tableDiagnostics = [];
    
        tableDiagnostics.push(
            [{ text: 'CIE-10 ', bold: true, style: 'tableheader' }, { text: 'Nombre', bold: true, style: 'tableheader' }, { text: 'Tipo', bold: true, style: 'tableheader' },  { text: 'Observación', bold: true, style: 'tableheader' }],
        );
    
        try {
            for (let k = 0; k < data.diagnosticoCie10?.diagnostico?.diagnostico.length; k++) {
                const element = data.diagnosticoCie10?.diagnostico?.diagnostico[k];
                tableDiagnostics.push([
                    { text: element.codigo, style: 'textStyle' }, { text: element.nombre, style: 'textStyle' }, { text: element.tipo, style: 'textStyle' }, { text: element.observacion, style: 'textStyle' }
                ])
            }
        } catch (error) {
            console.log(error)
        }

        return tableDiagnostics
    }

    const diagnosticsCie10FromHc = () => {
        let tableDiagnostics = [];
    
        tableDiagnostics.push(
            [{ text: 'CIE-10 ', bold: true, style: 'tableheader' }, { text: 'Nombre', bold: true, style: 'tableheader' }],
        );
    
        try {
            for (let k = 0; k <  data.diagnostico?.addedDiagnostics.length; k++) {
                const element =  data.diagnostico?.addedDiagnostics[k];
                tableDiagnostics.push([
                    { text: element.codigo, style: 'textStyle' }, { text: element.nombre, style: 'textStyle' }
                ])
            }
        } catch (error) {
            console.log(error)
        }

        return tableDiagnostics
    }

    const labsExams = (exams) => {
        let tableLabsExams = [];

        tableLabsExams.push(
            [{ text: 'CUPS ', style: 'textStyle', bold: true }, { text: 'Descripción', style: 'textStyle', bold: true }, { text: 'Cant.', style: 'textStyle', bold: true }, { text: 'Observación', style: 'textStyle', bold: true },]
        );
        try {
            for (let i = 0; i < exams.length; i++) {
                const element = exams[i];
                tableLabsExams.push(
                    [{ text: element.cupscod, style: 'tableTexStyle' }, { text: element.cupsnom, style: 'tableTexStyle' }, { text: element.cantidad, style: 'tableTexStyle' }, { text: element.observation, style: 'tableTexStyle' }]
                )
            }
        } catch (error) {
            console.log(error);
        }

        return tableLabsExams
    }


    body[0] = [{ text: 'CUPS ', style: 'textStyle', bold: true }, { text: 'Descripción', style: 'textStyle', bold: true }];
    if (data.from === 'IMP') {

        if(!!data.ordenes.ordenes.ordenes.addedDiagnostics){
            if(!!data.ordenes.ordenes.ordenes.addedDiagnostics.length){
                let observ = data.ordenes.ordenes.ordenes.observations;
                let amount = data.ordenes.ordenes.ordenes.amount;
                let examsPlusObservations = data.ordenes.ordenes.ordenes.addedDiagnostics.map((exam, index) => {
                    let cExam = exam
                    cExam.observation = observ[index];
                    cExam.cantidad = !!amount ? amount[index] : '';
                    return cExam
                })
            
                let laboratoryExams = examsPlusObservations.filter(exam => exam.tipo === 1 || exam.cupscod.substring(0, 2) === '90');
                let exams = data.ordenes.ordenes.ordenes.addedDiagnostics.filter(exam => (!exam.hasOwnProperty('tipo') || exam.tipo !== 1 ) && exam.cupscod.substring(0, 2) !== '90');
        
                if (!!laboratoryExams) {
                    if (!!laboratoryExams.length) {
                        docContent.push(
                            {
                                text: 'SOLICITUD DE PROCEDIMIENTOS', style: 'tableheader', alignment: 'center', margin: [0, 10, 0, 0],
                            },
                            {
                                text: 'Lugar y Fecha de la Prescripción: ' + getCity[0].ciunom + ', ' + format_today, style: 'textStyle', margin: [0, 10, 0, 0]
                            },
                            {
                                text: typeof data.third?.nombre === 'undefined' ? '' : 'ENTIDAD: ' + data.third?.nombre, style: 'textStyle', bold: true
                            },
                            basicPatientInfo(),
                            {
                                text: 'Diagnósticos', style: 'tableheader'
                            },
                            {
                                unbreakable: true,
                                margin: [0, 5, 0, 10],
                                layout: data.diagnosticoCie10?.diagnostico?.diagnostico.length === 0 ? 'noBorders' : 'headerLineOnly',
                                table: {
                                    widths: ['auto', '*', 'auto', 'auto'],
                                    headerRows: 1,
                                    body: diagnosticsCie10(),
                                },
                            },
                            {
                                text: 'Formulación Exámenes Laboratorio', style: 'tableheader'
                            },
                            {
                                margin: [0, 10, 0, 10],
                                layout: 'headerLineOnly',
                                table: {
                                    widths: ['auto', '*', 'auto', 'auto'],
                                    headerRows: 1,
                                    body: labsExams(laboratoryExams)
                                },
                            },
                            {
                                margin: [0, 10, 0, 10],
                                layout: 'noBorders',
                                table: {
                                    widths: ['auto', '*'],
                                    headerRows: 1,
                                    body: [
                                        [{ text: 'OBSERVACIONES ', style: 'textStyle', bold: true }, ''],
                                        [{ text: data.ordenes.ordenes.ordenes.observationAndProcedure, colSpan: 2, style: 'tableTexStyle' }, '']
                                    ]
                                },
                            },
                            // {
                            //     margin: [0, 50, 0, 0],
                            //     image: await getImage(urlFirma),
                            //     fit: [80, 80],
                            // },
                            // {
                            //     pageBreak: !!exams.length ? 'after' : '',
                            //     text: 'Dr.(a) ' + data.professional.nombres + ' ' + data.professional.apellido1 + ' ' + data.professional.apellido2 + '\n'
                            //         + data.professional.especialidad + '\n REG-' + data.professional.reg_medico, style: 'medicStyle'
                            // },
                            {
                                columns: signatures1
                            }
                        )
                    }
                }



                for (let i = 0; i < exams.length; i++) {

                    let signaturesArray;
                    if(i === exams.length-1){
                        signaturesArray = await generateSignature()
                    } else {
                        signaturesArray = await generateSignature("after")
                        
                    }
                    //body[i + 1] = [{ text: exams[i].cupscod, style: 'tableTexStyle' }, { text: exams[i].cupsnom, style: 'tableTexStyle' }];
                    docContent.push(
                        {
                            text: 'SOLICITUD DE PROCEDIMIENTOS', style: 'tableheader', alignment: 'center', margin: [0, 10, 0, 0],
                        },
                        {
                            text: 'Lugar y Fecha de la Prescripción: ' + getCity[0].ciunom + ', ' + format_today, style: 'textStyle', margin: [0, 10, 0, 0]
                        },
                        {
                            text: typeof data.third?.nombre === 'undefined' ? '' : 'ENTIDAD: ' + data.third?.nombre, style: 'textStyle', bold: true
                        },
                        basicPatientInfo(),
                        {
                            text: 'Diagnósticos', style: 'tableheader'
                        },
                        {
                            unbreakable: true,
                            margin: [0, 5, 0, 10],
                            layout: data.diagnosticoCie10?.diagnostico?.diagnostico.length === 0 ? 'noBorders' : 'headerLineOnly',
                            table: {
                                widths: ['auto', '*', 'auto', 'auto'],
                                headerRows: 1,
                                body: diagnosticsCie10(),
                            },
                        },
                        {
                            text: 'Formulación Exámenes', style: 'tableheader'
                        },
                        {
                            margin: [0, 10, 0, 10],
                            layout: 'headerLineOnly',
                            table: {
                                widths: ['auto', '*', 'auto', 'auto'],
                                headerRows: 1,
                                body: [
                                    [{ text: 'CUPS ', style: 'textStyle', bold: true }, { text: 'Descripción', style: 'textStyle', bold: true }, { text: 'Cant.', style: 'textStyle', bold: true }, { text: 'Observacion', style: 'textStyle', bold: true },],
                                    [{ text: exams[i].cupscod, style: 'tableTexStyle' }, { text: exams[i].cupsnom, style: 'tableTexStyle' }, { text: exams[i].cantidad, style: 'tableTexStyle' }, { text: exams[i].observation, style: 'tableTexStyle' }]
                                ]
                            },
                        },
                        {
                            margin: [0, 10, 0, 10],
                            layout: 'noBorders',
                            table: {
                                widths: ['auto', '*'],
                                headerRows: 1,
                                body: [
                                    [{ text: 'OBSERVACIONES ', style: 'textStyle', bold: true }, ''],
                                    [{ text: data.ordenes.ordenes.ordenes.observationAndProcedure, colSpan: 2, style: 'tableTexStyle' }, '']
                                ]
                            },
                        },
                        // {
                        //     margin: [0, 50, 0, 0],
                        //     image: await getImage(urlFirma),
                        //     fit: [80, 80],
                        // },
                        // {
                        //     pageBreak: (i + 1) === exams.length ? '' : 'after',
                        //     text: 'Dr.(a) ' + data.professional.nombres + ' ' + data.professional.apellido1 + ' ' + data.professional.apellido2 + '\n'
                        //         + data.professional.especialidad + '\n REG-' + data.professional.reg_medico, style: 'medicStyle'
                        // },
                        {
                            columns: signaturesArray
                        }
                    );
        
                }

        
                if (data.ordenes.ordenes.ordenes.addedDiagnostics.length === 0 && data.ordenes.ordenes.ordenes.observationAndProcedure !== "" && data.ordenes.ordenes.ordenes.observationAndProcedure !== null && data.ordenes.ordenes.ordenes.observationAndProcedure !== undefined) {
                    docContent.push(
                        {
                            text: 'SOLICITUD DE PROCEDIMIENTOS', style: 'tableheader', alignment: 'center', margin: [0, 10, 0, 0],
                        },
                        {
                            text: 'Lugar y Fecha de la Prescripción: ' + getCity[0].ciunom + ', ' + format_today, style: 'textStyle', margin: [0, 10, 0, 0]
                        },
                        {
                            text: typeof data.third?.nombre === 'undefined' ? '' : 'ENTIDAD: ' + data.third?.nombre, style: 'textStyle', bold: true
                        },
                        basicPatientInfo(),
                        {
                            text: 'Diagnósticos', style: 'tableheader'
                        },
                        {
                            unbreakable: true,
                            margin: [0, 5, 0, 10],
                            layout: data.diagnosticoCie10?.diagnostico?.diagnostico.length === 0 ? 'noBorders' : 'headerLineOnly',
                            table: {
                                widths: ['auto', '*', 'auto', 'auto'],
                                headerRows: 1,
                                body: diagnosticsCie10(),
                            },
                        },
                        {
                            text: 'Formulación Exámenes', style: 'tableheader'
                        },
                        {
                            margin: [0, 10, 0, 10],
                            layout: 'noBorders',
                            table: {
                                widths: ['auto', '*'],
                                headerRows: 1,
                                body: [
                                    [{ text: 'OBSERVACIONES ', style: 'textStyle', bold: true }, ''],
                                    [{ text: data.ordenes.ordenes.ordenes.observationAndProcedure, colSpan: 2, style: 'tableTexStyle' }, '']
                                ]
                            },
                        },
                        // {
                        //     margin: [0, 50, 0, 0],
                        //     image: await getImage(urlFirma),
                        //     fit: [80, 80],
                        // },
                        // {
                        //     text: 'Dr.(a) ' + data.professional.nombres + ' ' + data.professional.apellido1 + ' ' + data.professional.apellido2 + '\n'
                        //         + data.professional.especialidad + '\n REG-' + data.professional.reg_medico, style: 'medicStyle'
                        // },
                        {
                            columns: signatures3
                        }
        
                    );
                }
            }
        }
    } else {
        for (let i = 0; i < data.ordenes.length; i++) {
            //body[i + 1] = [{ text: data.ordenes[i].cupscod, style: 'tableTexStyle' }, { text: data.ordenes[i].cupsnom, style: 'tableTexStyle' }];
            docContent.push(
                {
                    text: 'SOLICITUD DE PROCEDIMIENTOS', style: 'tableheader', alignment: 'center', margin: [0, 10, 0, 0],
                },
                {
                    text: 'Lugar y Fecha de la Prescripción: ' + getCity[0].ciunom + ', ' + format_today, style: 'textStyle', margin: [0, 10, 0, 0]
                },
                {
                    text: typeof data.third?.nombre === 'undefined' ? '' : 'ENTIDAD: ' + data.third?.nombre, style: 'textStyle', bold: true
                },
                basicPatientInfo(),
                {
                    text: 'Diagnósticos', style: 'tableheader'
                },
                {
                    unbreakable: true,
                    margin: [0, 5, 0, 10],
                    layout: data.diagnosticoCie10?.addedDiagnostics.length === 0 ? 'noBorders' : 'headerLineOnly',
                    table: {
                        widths: ['auto', '*'],
                        headerRows: 1,
                        body: diagnosticsCie10FromHc(),
                    },
                },
                {
                    text: 'Formulación Exámenes', style: 'tableheader'
                },
                {
                    margin: [0, 10, 0, 10],
                    layout: 'headerLineOnly',
                    table: {
                        widths: ['auto', '*', 'auto'],
                        headerRows: 1,
                        body: [
                            [{ text: 'CUPS ', style: 'textStyle', bold: true }, { text: 'Descripción', style: 'textStyle', bold: true }, { text: 'Observación', style: 'textStyle', bold: true },],
                            [{ text: data.ordenes[i].cupscod, style: 'tableTexStyle' }, { text: data.ordenes[i].cupsnom, style: 'tableTexStyle' }, { text: data.observations[i], style: 'tableTexStyle' }]
                        ]
                    },
                },
                {
                    margin: [0, 10, 0, 10],
                    layout: 'noBorders',
                    table: {
                        widths: ['auto', '*'],
                        headerRows: 1,
                        body: [
                            [{ text: 'OBSERVACIONES ', style: 'textStyle', bold: true }, ''],
                            [{ text: data.observationAndProcedure, colSpan: 2, style: 'tableTexStyle' }, '']
                        ]
                    },
                },
                // {
                //     margin: [0, 50, 0, 0],
                //     image: await getImage(urlFirma),
                //     fit: [80, 80],
                // },
                // {
                //     pageBreak: (i + 1) === data.ordenes.length ? '' : 'after',
                //     text: 'Dr.(a) ' + nombres + ' ' + apellido1 + ' ' + apellido2 + '\n'
                //         + esp + '\n REG-' + reg_medico, style: 'medicStyle'
                // },
                {
                    columns: signatures4
                }

            );

        }

        if (data.ordenes.length === 0 && data.ordenes.observationAndProcedure !== "" && data.ordenes.observationAndProcedure !== null && data.ordenes.observationAndProcedure !== undefined) {
            docContent.push(
                {
                    text: 'SOLICITUD DE PROCEDIMIENTOS', style: 'tableheader', alignment: 'center', margin: [0, 10, 0, 0],
                },
                {
                    text: 'Lugar y Fecha de la Prescripción: ' + getCity[0].ciunom + ', ' + format_today, style: 'textStyle', margin: [0, 10, 0, 0]
                },
                {
                    text: typeof data.third?.nombre === 'undefined' ? '' : 'ENTIDAD: ' + data.third?.nombre, style: 'textStyle', bold: true
                },
                basicPatientInfo(),
                {
                    unbreakable: true,
                    margin: [0, 5, 0, 10],
                    layout: data.diagnostico?.addedDiagnostics.length === 0 ? 'noBorders' : 'headerLineOnly',
                    table: {
                        widths: ['auto', '*'],
                        headerRows: 1,
                        body: diagnosticsCie10FromHc(),
                    },
                },
                {
                    text: 'Formulación Exámenes', style: 'tableheader'
                },
                {
                    margin: [0, 10, 0, 10],
                    layout: 'noBorders',
                    table: {
                        widths: ['auto', '*'],
                        headerRows: 1,
                        body: [
                            [{ text: 'OBSERVACIONES ', style: 'textStyle', bold: true }, ''],
                            [{ text: data.observationAndProcedure, colSpan: 2, style: 'tableTexStyle' }, '']
                        ]
                    },
                },
                // {
                //     margin: [0, 50, 0, 0],
                //     image: await getImage(urlFirma),
                //     fit: [80, 80],
                // },
                // {
                //     text: 'Dr.(a) ' + nombres + ' ' + apellido1 + ' ' + apellido2 + '\n'
                //         + esp + '\n REG-' + reg_medico, style: 'medicStyle'
                // },
                {
                    columns: signatures5
                }
            );
        }
    }


    const documentDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        header: header,
        pageMargins: [20, 50, 20, 20],
        footer: function (currentPage, pageCount) {

            return {
                table: {
                    widths: ['*', '*', '*'],
                    body: [
                        [{ text: "Página " + currentPage.toString() + ' de ' + pageCount, style: 'head' }, { text: name, style: 'head' }, { text: 'Fecha Impresión: ' + format_today, style: 'head' }],
                    ]
                },
                layout: 'noBorders',
                margin: [20, 0, 0, 5],
            };
        },
        content: docContent,
        styles: {
            head: {
                fontSize: 7,
                bold: true,
                alignment: 'left'
            },
            tableheader: {
                fontSize: 11,
                bold: true,
            },
            textStyle: {
                fontSize: 9,
            },
            tableTexStyle: {
                fontSize: 8,
                alignment: 'left'
            },
            foter: {
                alignment: 'center',
                fontSize: 6,
            },
            medicStyle: {
                margin: [0, 10, 0, 0],
                fontSize: 9,
                alignment: 'left',
                font: 'OpenSans',
                bold: true
            }
        }
    };


    if (data.from === 'IMP') {
        const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
        pdfDocGenerator.getDataUrl(function (outDoc) {
            document.getElementById('pdfV').src = outDoc;
        });
    } else {
        pdfMake.createPdf(documentDefinition).open();
    }

    function applyVerticalAlignment(node, rowIndex, align, manualHeight = 0) { // New default argument
        const allCellHeights = node.table.body[rowIndex].map(
            (innerNode, columnIndex) => {
                if (innerNode._span) return null
                const calcWidth = [...Array(innerNode.colSpan || 1).keys()].reduce((acc, i) => {
                    return acc + node.table.widths[columnIndex + i]._calcWidth
                }, 0)
                const mFindInlineHeight = findInlineHeight(innerNode, calcWidth, 0, rowIndex, columnIndex)
                return mFindInlineHeight.height;
            }
        );
        const maxRowHeight = manualHeight ? manualHeight[rowIndex] : Math.max(...allCellHeights); // handle manual height
        node.table.body[rowIndex].forEach((cell, ci) => {
            if (allCellHeights[ci] && maxRowHeight > allCellHeights[ci]) {
                let topMargin;
    
                let cellAlign = align;
                if (Array.isArray(align)) {
                    cellAlign = align[ci];
                }
    
                if (cellAlign === 'bottom') {
                    topMargin = maxRowHeight - allCellHeights[ci];
                } else if (cellAlign === 'center') {
                    topMargin = (maxRowHeight - allCellHeights[ci]) / 2;
                }
    
                if (topMargin) {
                    if (cell._margin) {
                        cell._margin[1] = topMargin;
                    } else {
                        cell._margin = [0, topMargin, 0, 0];
                    }
                }
            }
        });
      }

      function findInlineHeight(cell, maxWidth, usedWidth = 0) {
        function mapTableBodies(innerTableCell) {
            const inlineHeight = findInlineHeight(
                innerTableCell,
                maxWidth,
                usedWidth
            );
        
            usedWidth = inlineHeight.width;
            return inlineHeight.height;
        }
        let calcLines = (inlines) => {
            if (!inlines)
                return {
                    height: 0,
                    width: 0,
                };
            let currentMaxHeight = 0;
            let lastHadLineEnd = false;
            for (const currentNode of inlines) {
                usedWidth += currentNode.width;
                if (usedWidth > maxWidth || lastHadLineEnd) {
                    currentMaxHeight += currentNode.height;
                    usedWidth = currentNode.width;
                } else {
                    currentMaxHeight = Math.max(currentNode.height, currentMaxHeight);
                }
                lastHadLineEnd = !!currentNode.lineEnd;
            }
            return {
                height: currentMaxHeight,
                width: usedWidth,
            };
        }
        if (cell._offsets) {
            usedWidth += cell._offsets.total;
        }
        if (cell._inlines && cell._inlines.length) {
            return calcLines(cell._inlines);
        } else if (cell.stack && cell.stack[0]) {
            return cell.stack.map(item => {
                return findInlineHeight(item, maxWidth);
            }).reduce((prev, next) => {
                return {
                    height: prev.height + next.height,
                    width: Math.max(prev.width + next.width)
                };
            });
        } else if (cell.table) {
            let currentMaxHeight = 0;
            for (const currentTableBodies of cell.table.body) {
                const innerTableHeights = currentTableBodies.map(mapTableBodies);
                currentMaxHeight = Math.max(...innerTableHeights, currentMaxHeight);
            }
            return {
                height: currentMaxHeight,
                width: usedWidth,
            };
        } else if (cell._height) {
            usedWidth += cell._width;
            return {
                height: cell._height,
                width: usedWidth,
            };
        }
    
        return {
            height: null,
            width: usedWidth,
        };
    }
}
export default PdfProceduresFormat;